import React from "react";
import NavigationSettingTable from "./NavigationSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showNavigationSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function NavigationSetting() {
  const dispatch = useDispatch();
  const { navigationSetting } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showNavigationSetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>NavigationSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>NavigationSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <NavigationSettingTable dataSource={navigationSetting} />
        </div>
      </div>
    </>
  );
}
